import { Skeleton, Stack, styled } from "@schaeffler-commerce/design-system";
import { C_OUTLINE_VARIANT, C_PRIMARY } from "@schaeffler-commerce/design-system";

export const Pagination = () => (
  <PaginationContainer>
    {[...Array(4)].map((e, i) => {
      return <Dot isFirst={i == 0} />;
    })}
  </PaginationContainer>
);

const PaginationContainer = styled(Stack)({
  flexDirection: "row",
  gap: "8px",
  alignSelf: "center",
});

const Dot = styled(Skeleton, {
  shouldForwardProp: (prop) => prop !== "isFirst",
})<{ isFirst: boolean }>(({ isFirst }) => ({
  width: isFirst ? "16px" : "8px",
  height: "8px",
  variants: isFirst ? "rectangular" : "circular",
  backgroundColor: isFirst ? C_PRIMARY : C_OUTLINE_VARIANT,
}));
